const pageNameKey = "otaEmptyPlaceholder";

export const otaEmptyPlaceholderEn = {
  [pageNameKey]: {
    noBackupsText: "No backups created yet.",
  },
};

export const otaEmptyPlaceholderPtBr = {
  [pageNameKey]: {
    noBackupsText: "Nenhum backup foi criado ainda.",
  },
};

export const otaEmptyPlaceholderDe = {
  [pageNameKey]: {
    noBackupsText: "Noch keine Backups erstellt.",
  },
};

export const otaEmptyPlaceholderZhHans = {
  [pageNameKey]: {
    noBackupsText: "尚未创建备份。",
  },
};

export const otaEmptyPlaceholderIt = {
  [pageNameKey]: {
    noBackupsText: "Nessun backup ancora creato.",
  },
};

export const otaEmptyPlaceholderEs = {
  [pageNameKey]: {
    noBackupsText: "Aún no se han creado copias de seguridad.",
  },
};

export const otaEmptyPlaceholderNl = {
  [pageNameKey]: {
    noBackupsText: "Er zijn nog geen back-ups gemaakt.",
  },
};

export const otaEmptyPlaceholderTr = {
  [pageNameKey]: {
    noBackupsText: "Henüz yedek oluşturulmadı.",
  },
};
